import { render, staticRenderFns } from "./audit-alipay.vue?vue&type=template&id=461c951d&scoped=true&"
import script from "./audit-alipay.vue?vue&type=script&lang=js&"
export * from "./audit-alipay.vue?vue&type=script&lang=js&"
import style0 from "./audit-alipay.vue?vue&type=style&index=0&id=461c951d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461c951d",
  null
  
)

export default component.exports